/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { useToast } from "../../../context/toast-context";
import useAPIHandler from "../../../hook/use-api-handler";
import { OrgWeeklyOffSchema } from "./org-weekly-off-validation";
import { WEEKLY_OFF_INITIAL_STATE } from "./weekly-off-constant";
import { useParams } from "react-router-dom";
import { useEmployeeContext } from "../../../context/employee-context";
import useBenifitService from "../../organization/benefit/use-benefit-service";
const useOrgWeeklyOffService = () => {
    const {id}=useParams()
      const {
        leaveStating
      } = useEmployeeContext() || {};
    
    const [orgWeeklyOffModal, setOrgWeeklyOffModal] = useState(false);
    const {benefitViewData}=useBenifitService()

    const handleClickOrgWeeklyOffModalOpen = () => setOrgWeeklyOffModal(true);
    const handleClickOrgWeeklyOffModalClose = () => setOrgWeeklyOffModal(false);
    const [orgWeeklyOffInputs, setOrgWeeklyOffInputs] = useState(structuredClone(WEEKLY_OFF_INITIAL_STATE))
    const [orgWeeklyOffData, setOrgWeeklyOffData] = useState([]);
    // const [orgWeeklyOffUiLoading, setOrgWeeklyOffUiLoading] = useState(false);
    const [errors, setErrors] = useState([])
    const [createFormUpdateLoading, setCreateFormUpdateLoading] = useState(false);
    const [orgWeeklyOffDeleteModal, setOrgWeeklyOffDeleteModal] = useState(false)
    const [selectedOrgWeeklyOff, setSelectedOrgWeeklyOff] = useState(null)
    const { fetchData } = useAPIHandler()
    const { showToastMessage } = useToast();
    const handleClickOpenAddModal = () => {
        setOrgWeeklyOffInputs(structuredClone(WEEKLY_OFF_INITIAL_STATE));
        setErrors({});
        handleClickOrgWeeklyOffModalOpen();
    }
    const handleClickOpenEditModal = (data) => {
      
        setErrors({});
        handleClickOrgWeeklyOffModalOpen()
        setOrgWeeklyOffInputs({
            ...data
        })
    }
    const handleClickOpenDeleteModal = () => {
        setOrgWeeklyOffDeleteModal(true)
    }
    const handleClickCloseDeleteModal = () => {
        setOrgWeeklyOffDeleteModal(false)
    }
    const handleChange = (e, name) => {
        let value = e;
        if (e & e.target) {
            value = e.target.value;
            name = e.target.name
        }
        setOrgWeeklyOffInputs((prevInfo) => ({
            ...prevInfo,
            [name]: value
        }))
    }
    const handleSubmit = async () => {
        setCreateFormUpdateLoading(true);
        const {
            days,
            repeat
        } = orgWeeklyOffInputs || {};
        const { error } = OrgWeeklyOffSchema.validate({
            days,
            repeat
        }, {
            abortEarly: false,
        });
        if (error && error?.details?.length > 0) {
            const validationErrors = error.details.reduce((acc, err) => {
                const pathname = err.path.join(".");
                acc[pathname] = err.message;
                return acc;
            }, {});
            setErrors(validationErrors)
            setCreateFormUpdateLoading(false);
        } else {
            setErrors({});
            try {
                const url = orgWeeklyOffInputs?.weekly_holiday_id ? `employee/update-employee-weekly-holiday/${id}/update/${orgWeeklyOffInputs.weekly_holiday_id}` : `employee/create-employee-weekly-holiday/${id}`
                const payload = {
                    url: url,
                    method: "POST",
                    data: {
                        days,
                        repeat
                    }
                }
                const response = await fetchData(payload);
                if (response?.data?.weekly_holiday_id) {

                    showToastMessage({ message: "Orgranization Weeklyoff Created Successfully!" })
                    fetchOrgWeeklyOffData();
                }
                setCreateFormUpdateLoading(false);
                handleClickOrgWeeklyOffModalClose()
            } catch (error) {
                if (error?.type === "JoiValidationError") {
                    const errorsAll = {};
                    error?.errors?.map((item) => {
                        const { field, message } = item;
                        errorsAll[field] = message;
                    });

                    showToastMessage({
                        message:
                            Object.keys(errorsAll).length > 0
                                ? "Validation Error!"
                                : "Something went wrong!",
                        color: "danger",
                    });
                    setErrors(errorsAll);
                }

                if (error?.type === "GeneralError") {
                    showToastMessage({
                        message: error.message || "An unknown general error occurred.",
                        color: "danger",
                    });
                }
                setCreateFormUpdateLoading(false);
                handleClickOrgWeeklyOffModalClose()
            }
        }
    }

    const fetchOrgWeeklyOffData = async () => {
        // setOrgWeeklyOffUiLoading(true);
        try {
            const result = await fetchData({
                url: `/employee/employee-weekly-holidays/${id}?weekoff=${!leaveStating?"emp_label":"org_label"}`,
                method: 'GET',
            });
            // setOrgWeeklyOffUiLoading(false)
            setOrgWeeklyOffData(result?.data)
        } catch {
            // setOrgWeeklyOffUiLoading(false)
        }
    }


    const handleClickDeletebtn = (data) => {
        handleClickOpenDeleteModal();
        setSelectedOrgWeeklyOff(data);
    }
    const handleDelete = async () => {
        setCreateFormUpdateLoading(true);
        try {
            await fetchData({
                url: `employee/delete-employee-weekly-holiday/${id}/${selectedOrgWeeklyOff?.weekly_holiday_id}`,
                method: 'DELETE',
                data: []
            })
            showToastMessage({ message: "Weekly Off Deleted successfully!" });
            handleClickCloseDeleteModal();
            fetchOrgWeeklyOffData();
            setCreateFormUpdateLoading(false);
        } catch (error) {
            if (error?.type === "JoiValidationError") {
                const errorsAll = {};

                error?.errors?.map((item) => {
                    const { field, message } = item;
                    errorsAll[field] = message;
                });

                showToastMessage({
                    message:
                        Object.keys(errorsAll).length > 0
                            ? "Validation Error!"
                            : "Something went wrong!",
                    color: "danger",
                });
                setErrors(errorsAll);
            }

            if (error?.type === "GeneralError") {
                showToastMessage({
                    message: error.message || "An unknown general error occurred.",
                    color: "danger",
                });
            }
            setCreateFormUpdateLoading(true);
        }

    }
    useEffect(() => {
        fetchOrgWeeklyOffData();
    }, [])
    return {
        orgWeeklyOffModal,
        handleClickOrgWeeklyOffModalOpen,
        handleClickOrgWeeklyOffModalClose,
        handleChange,
        handleSubmit,
        orgWeeklyOffInputs,
        setOrgWeeklyOffInputs,
        errors,
        orgWeeklyOffData,
        handleClickOpenEditModal,
        handleClickOpenAddModal,
        orgWeeklyOffDeleteModal,
        handleClickOpenDeleteModal,
        handleClickCloseDeleteModal,
        handleClickDeletebtn,
        handleDelete,
        createFormUpdateLoading,
        benefitViewData
    }
}

export default useOrgWeeklyOffService